import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApplicationInterface, ApplicationMetaInterface } from '@interface/application/application.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { baseReducerActions } from '@util/data/base-reducer-actions';
import { mapifyPayload } from '@util/store/mapify-payload';

import { initialApplicationsState } from './applications.initial-state';

export const applicationsSlice = createSlice({
  name: 'applications',
  initialState: initialApplicationsState,
  reducers: {
    ...baseReducerActions(initialApplicationsState),
    setData: (state, { payload }: PayloadAction<ResponseDataInterface<ApplicationInterface[]>>) => {
      state.data = mapifyPayload(payload.data);
    },
    setApplication: (state, { payload: { data } }: PayloadAction<ResponseDataInterface<ApplicationInterface>>) => {
      state.data[data.id] = data;
    },
    setCurrentApplication: (state, { payload }: PayloadAction<string>) => {
      state.meta.currentId = payload ?? '';
    },
    setAccess: (state, { payload }: PayloadAction<ApplicationMetaInterface>) => {
      state.meta.accessToken = payload.accessToken;
    },
  },
});

export const applicationsActions = applicationsSlice.actions;
